import React from 'react';
import CountUp from 'react-countup';
import { config } from '../../../../config/index';
const { SERVER_URL } = config;

const AssociateNameScore = ({ selectedAssociatePerformance, placeholderImage }) => {
  return (
    <>
      <div className="me-5 pt-3">
        <img
          src={
            selectedAssociatePerformance.image
              ? `${SERVER_URL}/${selectedAssociatePerformance.image}`
              : placeholderImage
          }
          alt="default"
          className="rounded-circle border me-2"
          style={{ height: '30px', width: '30px' }}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = placeholderImage;
          }}
        />
        <span className="associate-name fw-semibold ">
          {selectedAssociatePerformance?.associate_name
            ? selectedAssociatePerformance?.associate_name
            : '--'}
        </span>
      </div>
      <div>
        <h2 className="associate-manage-score p-2 px-4 rounded">
          {selectedAssociatePerformance?.score ? (
            <>
              <CountUp
                start={0}
                end={selectedAssociatePerformance?.score}
                duration={2}
                separator=""
                className=""
              />
              <span>%</span>
            </>
          ) : (
            '--'
          )}
        </h2>
      </div>
    </>
  );
};

export default AssociateNameScore;
